<script>
import Errors from '@/utils/Errors'
import ActionForm from '@/mixins/ActionForm'

export default {

    name: 'forgot-password-form',

    mixins: [ ActionForm ],

    methods:
    {
        forgot()
        {
            this.sendForm('authForgotPassword', this.model)
        },
    },

    data()
    {
        return {
            model: {
                email: null,
            }
        }

    },

}
</script>

<template lang="html">
    <form @submit.prevent="forgot">
        <div class="container">
            <div class="row mb-2">
                <div class="col-12">
                    <h3 class="font-weight-semibold">Forgot password</h3>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12">
                    <simple-input
                    type="email"
                    preText="Email"
                    v-model="model.email"
                    noRadius
                    ></simple-input>
                    <span class="text-sm text-orange" v-if="errors.has('email')">
                        {{ errors.first('email') }}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <custom-button buttonType="submit" classes="text-white text-uppercase full purple" text="Reset Password" :disabled="loading"></custom-button>
                    <div class="py-2 text-center text-purple font-weight-semibold">
                        <router-link :to="{ name: 'login'}">
                            Back to Sign In
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>



// WEBPACK FOOTER //
// src/components/forms/ForgotPassword.vue